import { render, staticRenderFns } from "./nav-menu.vue?vue&type=template&id=a3e89c96&scoped=true"
import script from "./nav-menu.vue?vue&type=script&lang=js"
export * from "./nav-menu.vue?vue&type=script&lang=js"
import style0 from "./nav-menu.vue?vue&type=style&index=0&id=a3e89c96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e89c96",
  null
  
)

export default component.exports